import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  createNewPipeline,
  createNewSingleOpportunity,
  deletePipeline,
  fetchAllPipelines,
  fetchNewCompanyInformation,
  performFetchUpdatedPipelineData,
  performMovePipelineData,
  retrieveSinglePipeline,
  updatePipeline,
  updateSingleOpportunity,
  deleteSingleOpportunity,
} from "../../networking/pipeline/networking";
import * as types from "../types/pipeline";

function* fetchPipelines(action) {
  try {
    if (action.payload) {
      const pipelines = yield call(fetchAllPipelines, action.payload);
      if (pipelines.error === null) {
        yield put({
          type: types.GRANT_FETCH_ALL_PIPELINES,
          content: pipelines.payload,
        });
      } else {
        throw new Error("Kunne ikke hente pipelines.");
      }
    } else {
      throw new Error("Kunne ikke hente pipelines.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FETCH_ALL_PIPELINES, message: e });
  }
}

function* fetchSinglePipeline(action) {
  try {
    if (action.payload) {
      const pipeline = yield call(retrieveSinglePipeline, action.payload);
      if (pipeline.error === null) {
        yield put({
          type: types.SET_SINGLE_PIPELINE_DETAILS,
          content: pipeline.payload,
        });
      } else {
        throw new Error("Kunne ikke hente pipeline.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_PIPELINE_DETAILS, message: e });
  }
}

function* movePipelineData(action) {
  try {
    if (action.payload) {
      const move = yield call(performMovePipelineData, action.payload);
      if (move.error === null) {
        yield put({ type: types.GRANT_MOVE_PIPELINE_DATA });
      } else {
        throw new Error("Kunne ikke flytte data.");
      }
    } else {
      throw new Error("Kunne ikke flytte data.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_MOVE_PIPELINE_DATA, message: e });
  }
}

function* fetchUpdatedPipeline(action) {
  try {
    if (action.payload) {
      const updated = yield call(
        performFetchUpdatedPipelineData,
        action.payload
      );
      if (updated.error === null) {
        yield put({
          type: types.SET_UPDATED_PIPELINE_DETAILS,
          content: updated.payload,
        });
      } else {
        throw new Error("Kunne ikke flytte data.");
      }
    } else {
      throw new Error("Kunne ikke flytte data.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATED_PIPELINE_DETAILS, message: e });
  }
}

function* performSearchSingleCompany(action) {
  try {
    if (action.id) {
      var response = yield call(fetchNewCompanyInformation, action.id);
      if (response && Object.keys(response).length > 0) {
        yield put({
          type: types.GRANT_SEARCH_SINGLE_COMPANY,
          response: response.contacts[0],
        });
      } else {
        throw new Error("Kunne ikke hende kundeinformasjon");
      }
    } else {
      throw new Error("Kunne ikke hente kundeinformasjon.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SEARCH_SINGLE_COMPANY, message: e });
  }
}

function* performAddSingleOpportunity(action) {
  try {
    var response = yield call(createNewSingleOpportunity, action.details);
    if (response.error === null) {
      yield put({ type: types.GRANT_ADD_SINGLE_OPPORTUNITY });
      yield put({
        type: types.CHANGE_PIPELINES_MODALS,
        modal: { addUnitPipelineModal: false },
      });
    } else {
      throw new Error("Kunne ikke legge til ny kunde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_SINGLE_OPPORTUNITY, message: e });
  }
}

function* performUpdateSingleOpportunity(action) {
  try {
    if (action.details) {
      var response = yield call(updateSingleOpportunity, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_SINGLE_OPPORTUNITY });
        yield put({
          type: types.CHANGE_PIPELINES_MODALS,
          modal: { editUnitPipelineModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_SINGLE_OPPORTUNITY, message: e });
  }
}

function* performDeleteSingleOpportunity(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleOpportunity, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_SINGLE_OPPORTUNITY });
        yield put({
          type: types.CHANGE_PIPELINES_MODALS,
          modal: { deletePipelineUnitModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_SINGLE_OPPORTUNITY, message: e });
  }
}

function* performCreateNewPipeline(action) {
  try {
    if (action.details) {
      var response = yield call(createNewPipeline, action.details);
      if (response.error === null) {
        yield put({ type: types.SET_CREATE_NEW_PIPELINE, id: response.id });
        yield put({
          type: types.CHANGE_PIPELINES_MODALS,
          modal: { newPipelineModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CREATE_NEW_PIPELINE, message: e });
  }
}

function* performUpdateSinglePipeline(action) {
  try {
    if (action.details) {
      var response = yield call(updatePipeline, action.details);
      if (response.error === null) {
        yield put({
          type: types.GRANT_UPDATE_SINGLE_PIPELINE,
          id: response.id,
        });
        yield put({
          type: types.CHANGE_PIPELINES_MODALS,
          modal: { editPipelineModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere pipeline.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere pipeline.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_SINGLE_PIPELINE, message: e });
    yield put({
      type: types.CHANGE_PIPELINES_MODALS,
      modal: { editPipelineModal: false },
    });
  }
}

function* performDeleteSinglePipeline(action) {
  try {
    if (action.details) {
      var response = yield call(deletePipeline, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_SINGLE_PIPELINE });
        yield put({
          type: types.CHANGE_PIPELINES_MODALS,
          modal: { editPipelineModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere pipeline.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere pipeline.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_SINGLE_PIPELINE, message: e });
    yield put({
      type: types.CHANGE_PIPELINES_MODALS,
      modal: { editPipelineModal: false },
    });
  }
}

function* pipelineSaga() {
  yield all([
    takeEvery(types.REQUEST_FETCH_ALL_PIPELINES, fetchPipelines),
    takeEvery(types.REQUEST_SINGLE_PIPELINE_DETAILS, fetchSinglePipeline),
    takeEvery(types.REQUEST_MOVE_PIPELINE_DATA, movePipelineData),
    takeEvery(types.REQUEST_UPDATED_PIPELINE_DETAILS, fetchUpdatedPipeline),
    takeEvery(types.REQUEST_SEARCH_SINGLE_COMPANY, performSearchSingleCompany),
    takeEvery(
      types.REQUEST_ADD_SINGLE_OPPORTUNITY,
      performAddSingleOpportunity
    ),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_OPPORTUNITY,
      performUpdateSingleOpportunity
    ),
    takeEvery(
      types.REQUEST_DELETE_SINGLE_OPPORTUNITY,
      performDeleteSingleOpportunity
    ),
    takeEvery(types.REQUEST_CREATE_NEW_PIPELINE, performCreateNewPipeline),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_PIPELINE,
      performUpdateSinglePipeline
    ),
    takeEvery(
      types.REQUEST_DELETE_SINGLE_PIPELINE,
      performDeleteSinglePipeline
    ),
  ]);
}

export default pipelineSaga;
